import { MutationCache, QueryClient } from '@tanstack/react-query';
import { errorTitle, isApiError } from '../api';
import { toast } from './toast';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      /** Set true when the calling component renders the error itself. */
      silent?: boolean;
    };
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        if (isApiError(err) && err.status > 0 && err.status < 500) return false;
        return count < 2;
      },
    },
  },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.silent) return;
      // Field-level 422s are shown inline by forms; still surface the title.
      toast.error(errorTitle(err), isApiError(err) ? err.detail : undefined);
    },
  }),
});
